// packages/content/src/tuning/house.ts — levels[0] cost = move-in fee; levels[n].cost = loan started when level n is built
import type { TuningBank } from '../schema/tuning';
export default {
  levels: [
    { rooms: [[4, 4]], cost: 5000 },
    { rooms: [[6, 6]], cost: 60_000 },
    { rooms: [[8, 8]], cost: 150_000 },
    { rooms: [[8, 8], [6, 6]], cost: 300_000 },
    { rooms: [[8, 8], [6, 6], [6, 6]], cost: 500_000 },
  ],
  interestRate: 0, defaultWallpaper: 'wall.cream_plain', defaultFloor: 'floor.oak_planks',
} as const satisfies TuningBank;
